import React, { useEffect, useState } from "react";
import { Box, VStack, Heading, AspectRatio } from "@chakra-ui/react";
import { getLatestVideos } from "../../../services/videoService";
import VideosNavbar from "../../../components/navbars/vdeosNavbar/videosNavbar";
import { useUserAuthorization } from "../../../context/UserRoleAndAuthContext";
import Loader from "../../../components/common/Loader";

const DashboardPage = () => {
  const [latestVideos, setLatestVideos] = useState([]);
  const { role, loading } = useUserAuthorization();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const result = await getLatestVideos();
        if (result) {
          setLatestVideos(result || []);
        }
      } catch (error) {
        console.error("Error in fetchVideos:", error);
      }
    };

    fetchVideos();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Box dir="ltr">
      {role && role !== "visitor" ? (
        <VideosNavbar>
          <VStack spacing={8} align="stretch">
            <Heading size="lg" color="white" dir="rtl">
              הוספו לאחרונה
            </Heading>
            {latestVideos.map((video) => {
              let videoId = "";
              if (video.url.includes("watch?v=")) {
                videoId = video.url.split("watch?v=")[1].split("&")[0];
              } else if (video.url.includes("/shorts/")) {
                videoId = video.url.split("/shorts/")[1].split("?")[0];
              }

              const embedUrl = `https://www.youtube.com/embed/${videoId}`;

              return (
                <Box
                  key={video.videoId}
                  bg="white"
                  shadow="md"
                  borderRadius="md"
                  overflow="hidden"
                >
                  <Box p={4}>
                    <Heading size="md" dir="rtl">
                      {video.title}
                    </Heading>
                  </Box>
                  <AspectRatio ratio={16 / 9}>
                    <iframe
                      src={embedUrl}
                      title={video.title}
                      allowFullScreen
                    />
                  </AspectRatio>
                </Box>
              );
            })}
          </VStack>
        </VideosNavbar>
      ) : (
        <Box>Welcome user! You have limited access.</Box>
      )}
    </Box>
  );
};

export default DashboardPage;
